import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { useAuth } from '@/lib/auth';
import { AdminPage } from '@/pages/Admin';
import { AirportPage } from '@/pages/Airport';
import { ComparePage } from '@/pages/Compare';
import { GatePage } from '@/pages/Gate';
import { HomePage } from '@/pages/Home';
import { MorePage } from '@/pages/More';
import { CalendarImportPage } from '@/pages/CalendarImport';
import { NewTripPage } from '@/pages/NewTrip';
import { PrintPlanPage } from '@/pages/PrintPlan';
import { ProfilePage } from '@/pages/Profile';
import { TripDetailPage } from '@/pages/TripDetail';
import { TripsPage } from '@/pages/Trips';
import { WalletPage } from '@/pages/Wallet';

function RequireAuth() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="mx-auto flex min-h-screen max-w-[430px] items-center justify-center bg-sand text-sm text-muted">
        Loading Concourse…
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return <Outlet />;
}

export function App() {
  const { user, loading } = useAuth();

  return (
    <Routes>
      <Route path="/" element={!loading && user ? <Navigate to="/app" replace /> : <GatePage />} />
      <Route element={<RequireAuth />}>
        <Route element={<Layout />}>
          <Route path="/app" element={<HomePage />} />
          <Route path="/wallet" element={<WalletPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/trips" element={<TripsPage />} />
          <Route path="/trips/import" element={<CalendarImportPage />} />
          <Route path="/trips/new" element={<NewTripPage />} />
          <Route path="/trips/:tripId" element={<TripDetailPage />} />
          <Route path="/trips/:tripId/print" element={<PrintPlanPage />} />
          <Route path="/airports/:iata" element={<AirportPage />} />
          <Route path="/compare" element={<ComparePage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/more" element={<MorePage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
